import { AxiosResponse } from 'axios'

import axios from '../../axios'

export const destroyRecruiter = async (
  id: string,
  agencyCode?: string
): Promise<AxiosResponse> => {
  const response = await axios
    .delete(`/api/recruiters/${id}`, {
      params: { agencyCode: agencyCode },
    })
    .catch((error) => {
      return error.response
    })

  return response
}
